// Module
var code = "<md-button type=\"button\" class=\"md-raised md-neutral md-big\" data-ng-click=\"$ctrl.cancel()\" aria-label=\"Cancel\">\n    Cancel\n</md-button>";
// Exports
module.exports = code;